import { Modal } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { BankSelectionBody } from './BankSelectionBody';

export const BankSelectionModal = ({
    isOpen,
    onClose
}: {
    isOpen: boolean;
    onClose: () => void;
}) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            closeIcon={true}
            headerBar={true}
            title={
                <FormattedMessage
                    id="_.bank_selection_modal.title"
                    defaultMessage="Connect your business account"
                />
            }
            data-testid="bank-selection-modal"
            className="fs-mask dd-privacy-mask"
        >
            <BankSelectionBody />
        </Modal>
    );
};
